import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import home2 from './Component/s3.png';
import s2 from './Component/s2.png';
import showroomKitchen from './Component/home/4869.jpg';
import showroomHardware from './Component/home/4866.jpg';
import showroomTub from './Component/home/4865.jpg';
import showroomSink from './Component/home/4861.jpg';

const services = [
	{ label: 'Kitchen & Bath Showroom', href: '/kitchen-bath-showroom', highlight: true },
	{ label: 'Chief Construction Management', href: null },
	{ label: 'Bathroom Remodeling', href: '/bathroom-remodeling' },
	{ label: 'Blinds & Shutters', href: '/blinds-n-shutters' },
	{ label: 'Shaw Products', href: 'https://shawfloors.com/', external: true },
	{ label: 'Builder & Contractor Program', href: '/builder-n-contractor-program' },
	{ label: 'Design Services', href: '/design-services' },
	{ label: 'Onyx Showers & Vanities', href: null },
	{ label: 'Certified Waterproof Custom Showers', href: null },
	{ label: 'Cabinets & Cabinet Hardware', href: '/kitchen-bath-showroom' },
	{ label: 'Sinks, Faucets, Tubs & Toilets', href: '/kitchen-bath-showroom' },
	{ label: 'Design Consultation', href: null },
	{ label: 'Custom Area Rugs', href: null },
	{ label: 'Installation', href: null },
	{ label: 'Financing', href: '/financing' },
];

function Services() {
	return (
		<div className="bg-gray-50 min-h-screen">
			<Headers />

			<section className="bg-[#803333] text-white py-10 md:py-14">
				<div className="container mx-auto px-4 text-center">
					<h1 className="text-3xl md:text-4xl font-bold tracking-tight mb-2">Services</h1>
					<p className="text-white/85 text-sm md:text-base max-w-2xl mx-auto m-0">
						See why we&apos;re the Cassville, MO area&apos;s most trusted service provider
					</p>
				</div>
			</section>

			{/* New Kitchen & Bath callout */}
			<section className="container mx-auto px-4 py-10 md:py-12">
				<div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mb-6">
					<div className="row g-0 align-items-stretch">
						<div className="col-lg-5">
							<img
								src={showroomKitchen}
								alt="New kitchen and bath showroom"
								className="w-full h-100 min-h-[240px] object-cover"
							/>
						</div>
						<div className="col-lg-7">
							<div className="p-6 md:p-8 h-100 flex flex-col justify-center">
								<span className="inline-flex self-start items-center gap-2 bg-[#803333]/10 text-[#803333] text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full mb-3">
									New
								</span>
								<h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
									Kitchen & Bath Showroom
								</h2>
								<p className="text-gray-600 text-sm md:text-base mb-4 leading-relaxed">
									We now sell cabinets and hardware for cabinets, vanities, sinks, faucets, tubs, toilets — plus custom showers and all types of floors. Visit our new showroom displays in Cassville.
								</p>
								<a
									href="/kitchen-bath-showroom"
									className="inline-flex self-start items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
								>
									View Showroom
									<i className="bi bi-arrow-right" />
								</a>
							</div>
						</div>
					</div>
				</div>

				<div className="row g-3">
					{[
						{ src: showroomSink, alt: 'Farmhouse sink and faucet', label: 'Sinks & Faucets' },
						{ src: showroomTub, alt: 'Freestanding bathtub', label: 'Tubs' },
						{ src: showroomHardware, alt: 'Cabinet hardware', label: 'Hardware' },
					].map((item) => (
						<div key={item.label} className="col-4">
							<a href="/kitchen-bath-showroom" className="group block overflow-hidden rounded-xl border border-gray-100 shadow-sm no-underline">
								<img
									src={item.src}
									alt={item.alt}
									className="w-full aspect-square object-cover transition-transform duration-300 group-hover:scale-105"
								/>
								<p className="text-center text-xs md:text-sm font-semibold text-gray-800 py-2 m-0 bg-white group-hover:text-[#803333]">
									{item.label}
								</p>
							</a>
						</div>
					))}
				</div>
			</section>

			<section className="container mx-auto px-4 pb-10 md:pb-14">
				<div className="row g-4 g-lg-5 align-items-start">
					<div className="col-lg-5">
						<img
							src={home2}
							alt="Nickle's Flooring services"
							className="w-full h-auto rounded-2xl shadow-sm"
						/>
					</div>
					<div className="col-lg-7">
						<div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8">
							<h2 className="text-xl font-bold text-gray-900 mb-4">What we offer</h2>
							<ul className="list-none m-0 p-0 space-y-0">
								{services.map((item) => (
									<li
										key={item.label}
										className={`flex items-center justify-between gap-3 py-3 border-b border-gray-100 last:border-0 ${
											item.highlight ? 'bg-[#803333]/5 -mx-2 px-2 rounded-lg' : ''
										}`}
									>
										<span
											className={`text-sm md:text-base font-semibold ${
												item.highlight ? 'text-[#803333]' : 'text-gray-700'
											}`}
										>
											{item.label}
										</span>
										{item.href && (
											<a
												href={item.href}
												target={item.external ? '_blank' : undefined}
												rel={item.external ? 'noreferrer' : undefined}
												className="text-sm font-semibold text-[#803333] no-underline hover:underline whitespace-nowrap"
											>
												Learn more
											</a>
										)}
									</li>
								))}
							</ul>
							<div className="pt-5">
								<a
									href="/free-estimate"
									className="inline-flex items-center gap-2 bg-[#803333] text-white font-semibold text-sm px-5 py-2.5 rounded-lg no-underline hover:bg-[#6a2a2a] transition-colors"
								>
									Request an Estimate
									<i className="bi bi-arrow-right" />
								</a>
							</div>
						</div>
					</div>
				</div>

				<div className="mt-10">
					<a
						href="/financing"
						className="block overflow-hidden rounded-2xl shadow-sm hover:shadow-md transition-shadow"
					>
						<img
							src={s2}
							alt="Explore financing options"
							className="w-full h-auto d-block"
						/>
					</a>
				</div>
			</section>

			<Footer />
		</div>
	);
}

export default Services;
